export default "__VITE_ASSET__ClXX0fMc__"